import { Component, NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageNotFoundComponent } from 'src/app/layout/pages/page-not-found/page-not-found.component';
import { EditProfileComponent } from './edit-profile/edit-profile.component';
import { ProfileLogsComponent } from './profile-logs/profile-logs.component';

import { ProfileComponent } from './profile.component';

const profileRoutes: Routes = [
  { path: 'edit-profile', component: EditProfileComponent },
  { path: 'logs', component: ProfileLogsComponent },
  { path: '', redirectTo: 'edit-profile', pathMatch: 'full' },
  {
    path: '**', component: PageNotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(profileRoutes)],
  exports: [RouterModule]
})
export class ProfileRoutingModule { }
